const menuPhotos = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14">
      <g fill="none" fill-rule="evenodd" transform="translate(1 -2)">
        <g stroke="#F5F5F5" stroke-linecap="round" stroke-linejoin="round" transform="translate(0 2.25)">
          <path d="M17.625 11.625C17.625 12.03675 17.2875 12.375 16.875 12.375L1.125 12.375C.7125 12.375.375 12.03675.375 11.625L.375 2.625C.375 2.2125.7125 1.875 1.125 1.875L16.875 1.875C17.2875 1.875 17.625 2.2125 17.625 2.625L17.625 11.625zM2.25 1.875L2.25 1.125C2.25.7125 2.5875.375 3 .375L4.5.375C4.9125.375 5.25.7125 5.25 1.125L5.25 1.875M.375 4.625L6 4.625M.375 7.125L6 7.125M.375 9.625L6 9.625"/>
          <circle cx="12.375" cy="7.125" r="3.75"/>
          <rect width="3" height="3" x="10.875" y="5.625"/>
        </g>
        <rect width="18" height="18"/>
      </g>
    </svg>

`;

export default menuPhotos;
